import React from 'react';

import { MedicalCheckStatus } from '../../pages/LeadsManagement/utils/medicalCheckStatus';
import StatusBadgeIcon from './StatusBadgeIcon';

interface MedicalCheckIconProps {
    status?: MedicalCheckStatus | string | null;
}

const TITLE_BY_STATUS: Record<string, string> = {
    scheduled: 'Medical check scheduled',
    missed: 'Medical check missed',
    completed: 'Medical check completed',
    not_scheduled: 'Medical check not scheduled'
};

const MedicalCheckIcon: React.FC<MedicalCheckIconProps> = ({ status }) => {
    const done = status === 'completed' || status === 'scheduled';
    const title = TITLE_BY_STATUS[status as string] || TITLE_BY_STATUS.not_scheduled;
    return <StatusBadgeIcon done={done} title={title} />;
};

export default MedicalCheckIcon;
